import type { CreditPaymentInvoiceCommandData } from '@festina/moneyin-general-types/moneyin'
import { InvoicesPaymentCreditsService } from '@festina/moneyin-general-types/moneyin/services/InvoicesPaymentCreditsService'
import { PaymentsService } from '@festina/moneyin-general-types/moneyin/services/PaymentsService'
import { useFestinaMutation } from '@festina-life/authentication'
import type { Except } from '@festina-life/core'

import type { InvoiceActionProps } from '../types'

const method =
  InvoicesPaymentCreditsService.invoicePaymentCreditsServicePostCreate

export const useSubmitCreditPaymentInvoice = ({
  tenantId,
  invoiceId,
}: Except<InvoiceActionProps, 'commandId'>) =>
  useFestinaMutation({
    component: 'moneyIn',
    roles: PaymentsService.paymentsServicePostAttach_roles,
    isScenario: false,
    mutateFunction: async (arg: CreditPaymentInvoiceCommandData) => {
      await method({
        xTenantId: tenantId,
        requestBody: arg,
        invoiceId,
      })
    },
  })
